"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _classNames = _interopRequireDefault(require("react-utils/classNames"));

var _FieldsetContext = require("../context/FieldsetContext");

var LABEL_SIZE_OPTIONS = {
  default: '',
  small: 'private-form__label--small'
};

var _default = _react.default.createClass({
  displayName: "UIFormLabel",
  propTypes: {
    children: _react.PropTypes.node,
    error: _react.PropTypes.bool.isRequired,
    htmlFor: _react.PropTypes.string,
    readOnly: _react.PropTypes.bool.isRequired,
    required: _react.PropTypes.bool.isRequired
  },
  getDefaultProps: function getDefaultProps() {
    return {
      error: false,
      required: false,
      readOnly: false
    };
  },
  render: function render() {
    var _this$props = this.props,
        children = _this$props.children,
        className = _this$props.className,
        error = _this$props.error,
        readOnly = _this$props.readOnly,
        required = _this$props.required,
        rest = (0, _objectWithoutProperties2.default)(_this$props, ["children", "className", "error", "readOnly", "required"]);
    return _react.default.createElement(_FieldsetContext.Consumer, null, function (_ref) {
      var fieldSize = _ref.size;
      return _react.default.createElement("label", (0, _extends2.default)({}, rest, {
        className: (0, _classNames.default)('private-form__label', LABEL_SIZE_OPTIONS[fieldSize], className, {
          'private-form__label--readonly': readOnly,
          'private-form__label--required': required,
          'error-msg': error
        })
      }), children);
    });
  }
});

exports.default = _default;
module.exports = exports.default;